<template>
  <div
    class="grid p-2"
    :class="`gap-${gap}`"
    :style="`grid-template-columns: repeat(auto-fill, minmax(${minColumnWidth}rem, 1fr))`"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ minColumnWidth?: number; gap?: number }>(), {
  minColumnWidth: 4,
  gap: 4,
});
</script>
